<template>
  <div class="dashboard-container">
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'dashboard',
  data() {
    return {
      isLead: ''
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      permissionCodes: state => state.auth.permissionCodes
    })
  },
  methods: {
  },
  mounted() {
  }
}
</script>
